
import { t, onLocaleChange } from "../i18n/index.js";

const STORAGE_KEY = "dropl:consent_ack";
let root: HTMLElement | null = null;
let unsubLocale: (() => void) | null = null;

function alreadyAcknowledged(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {

    return true;
  }
}

function render(): void {
  if (!root) return;
  root.innerHTML = `
    <div class="consent-banner__inner">
      <p class="consent-banner__text">${escapeText(t("consent.text"))}</p>
      <button type="button" class="btn btn--primary btn--sm consent-banner__accept" data-consent-accept>
        <i class="fa-solid fa-check" aria-hidden="true"></i>
        <span>${escapeText(t("consent.accept"))}</span>
      </button>
    </div>`;
  root.setAttribute("aria-label", t("consent.aria_label"));
  root.querySelector<HTMLButtonElement>("[data-consent-accept]")?.addEventListener("click", () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch {  }
    dismiss();
  });
}

function dismiss(): void {
  if (!root) return;
  root.classList.add("consent-banner--leaving");
  const el = root;
  window.setTimeout(() => {
    el.remove();
    if (root === el) root = null;
    if (unsubLocale) { unsubLocale(); unsubLocale = null; }
  }, 200);
}

function escapeText(s: string): string {
  return s
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function initConsentBanner(): void {
  if (alreadyAcknowledged()) return;
  if (root) return;
  root = document.createElement("div");
  root.className = "consent-banner";
  root.setAttribute("role", "region");
  document.body.appendChild(root);
  render();
  unsubLocale = onLocaleChange(() => render());
}
